import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IGetPromcionCopi } from '@p-p-portafolio/promociones/interfaces/IGetPromcionCopi';
import { PromocionesService } from '@p-p-portafolio/services/promociones.service';

export interface IGetAllPromCopyRes {
  data: IGetAllPromCopy[];
  success: boolean;
}

export interface IGetAllPromCopy {
  sPromocion: string;
  descripcion: string;
  plazoMin: number;
  plazoMax: number;
  sEmpresa: any;
  sFechaI: any;
  sFechaF: string;
  moneda: any;
  sCartera: any;
  producto: null | string;
  claseCart: number;
  sSucursal: null | string;
}

@Component({
  selector: 'app-promociones-copy',
  templateUrl: './promociones-copy.component.html',
  styleUrls: ['./promociones-copy.component.css']
})
export class PromocionesCopyComponent implements OnInit {
  @Output() closeDialog = new EventEmitter();
  form: FormGroup;

  origenes: IGetAllPromCopy[] = [];
  descripciones = [];
  constructor(private fb: FormBuilder, private promocionesService: PromocionesService) {
    this.form = this.fb.group({
      origen: [null, Validators.required],
      destino: [null, Validators.required],
      copia: [null, Validators.required]
    });

    this.promocionesService.GetAll().subscribe((data) => {
      this.origenes = data.data;
    });
  }

  ngOnInit() {}

  onSubmit() {
    console.log(this.form.value);
    const payload: IGetPromcionCopi = {
      clave: this.form.get('origen')?.value,
      descripcion: this.form.get('destino')?.value,
      plazoMin: 1,
      plazoMax: this.form.get('copia')?.value === '2' ? 1 : 0,
      empresa: '',
      vigDesde: 0,
      vigHasta: 0,
      moneda: '',
      tipoCartera: '',
      tipoCredito: '',
      claseCart: 0,
      sSucursal: '1'
    };

    this.promocionesService.GetPromcionCopi(payload).subscribe({
        next: (res) => {
            if (res.success) {
                this.close();
            }
        },
        error: (err) => {
            console.log(err);
        }
    });
  }

  close() {
    this.closeDialog.emit();
  }
}
